/**
 * Created by alf on 07.03.21
 */

/**
 Example of Response from Azure OCR service, for image at:
 https://loremipsum.io/assets/images/lorem-ipsum-generator-custom-placeholder-text.jpg

   {
      "language": "de",
      "textAngle": 0.0,
      "orientation": "Up",
      "regions": [
        {
          "boundingBox": "109,335,653,60",
          "lines": [
            {
              "boundingBox": "109,335,653,60",
              "words": [
                {
                  "boundingBox": "109,335,175,44",
                  "text": "Lorem"
                },
                {
                  "boundingBox": "304,335,168,60",
                  "text": "Ipsum"
                },
                {
                  "boundingBox": "493,335,269,44",
                  "text": "Generator"
                }
              ]
            }
          ]
        }
      ]
    }

*/

import { Brick, registerBrick } from 'olympe';

export default class ParseAzureOCRResponse extends Brick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {string} jSONResponse
     * @param {function(string)} setPlainText
     * @param {function(Map)} setListOfLines
     */
    update(context, [jSONResponse], [setPlainText, setListOfLines]) {
        const listOfLines = new Map();
        let jsonObject;
        let plainText = '';
        let index = 0;
        try {
            jsonObject = JSON.parse(jSONResponse.valueOf());
            // OBJECT STRUCTURE = obj.regions[array]["lines"][array]["words"][array]["text"]
            for (const region of jsonObject["regions"]) {
                // Handle each line separately
                for (const line of region["lines"]) {
                    let currentLine = '';
                    for (const word of line["words"]) {
                        // add a space between each word
                        currentLine += (word["text"] + ' ');
                    }
                    // remove last space
                    currentLine = currentLine.substr(0, currentLine.length - 1);
                    // store new line (use the Region's bounding box as ID, so that we can retrieve them by region later)
                    listOfLines.set(region["boundingBox"] + '_' + index, currentLine);
                    // add line feed at the end of line
                    plainText += (currentLine + '\n');
                }
                // add line feed at the end of region (i.e. there will be an empty line between 2 regions)
                plainText += '\n';
            }
            setPlainText(plainText);
            setListOfLines(listOfLines);
        } catch (jsonErr) {
            console.error(jsonErr);
            setPlainText('Error while parsing OCR response.');
        }
    }
}

registerBrick('0178111fff8fac46dfb6', ParseAzureOCRResponse);
